import { render } from "./EcheckResult.vue?vue&type=template&id=dd4692e6&scoped=true"
import script from "./EcheckResult.vue?vue&type=script&lang=js"
export * from "./EcheckResult.vue?vue&type=script&lang=js"

import "./EcheckResult.vue?vue&type=style&index=0&id=dd4692e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd4692e6"]])

export default __exports__